import { Renderer2 } from '@angular/core';
import { Coordinates } from 'src/app/reports/components/report/models/coordinates.model';
import { appendExistStyleAttribute } from './element.helper';

export function setStyleToElement(element: any, style: string, value: any, renderer: Renderer2): void {
    renderer.setStyle(element, style, value);
}

export function setDinamicFlexStyleToChildren(element: any, renderer: Renderer2) {
    const items = element != null ? element.children : null;

    if (items != null && items.length > 0){
        const flex = 100 / items.length;

        for (const [index, value] of Object.entries(items)) {

            if (items.hasOwnProperty(index)) {
                const elm = items[index];
                this.setStyleToElement(elm, 'flex', `${flex}%`, renderer);
            }

        }
    }
}

export function getFlexStyleByArray(array: Array<any>) {
    const value = 100 / array.length,
    flex = '{0}%'.replace('{0}', value.toString());

    return flex;
}

export function setElementPositionByCoordinates(coordinates: Coordinates, elm: any, renderer: Renderer2) {
  const translate = `${coordinates.x}px,${coordinates.y}px,0px`,
    style = appendExistStyleAttribute(elm.style['transform'], 'translate3d', translate);

  renderer.setStyle(elm, 'transform', style);
}
